import {request} from 'api';

export async function listLanguages({lang}) {
    try {
        const {languages} = await request({
            method: 'GET',
            url: '/api/translate/languages',
            params: {baseLang: lang},
        });

        return languages;
    } catch (err) {
        throw new Error(err);
    }
}

export async function translate(params) {
    const {sourceLanguageCode = 'ru', targetLanguageCode = 'en', texts = []} = params;

    try {
        const {translations} = await request({
            method: 'POST',
            url: '/api/translate/translate',
            data: {
                sourceLanguageCode,
                targetLanguageCode,
                texts,
            },
        });

        return translations;
    } catch (err) {
        throw new Error(err);
    }
}

export async function detect(data) {
    try {
        const {languageCode} = await request({
            method: 'POST',
            url: '/api/translate/detect',
            data,
        });

        return languageCode;
    } catch (err) {
        throw new Error(err);
    }
}
